import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  expand: true,
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    expandSidebar: state => {
      state.expand = true;
    },
    collapseSidebar: state => {
      state.expand = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { expandSidebar, collapseSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
